import { Bot, Sparkles } from 'lucide-react';

import FeatureAiIcon from '@/assets/images/mobile-membership/feature-ai.svg';
import FeatureBellIcon from '@/assets/images/mobile-membership/feature-bell.svg';
import FeatureDashboardIcon from '@/assets/images/mobile-membership/feature-dashboard.svg';
import FeatureInquiryIcon from '@/assets/images/mobile-membership/feature-inquiry.svg';
import FeatureMarketIcon from '@/assets/images/mobile-membership/feature-market.svg';
import FeatureMonitoringIcon from '@/assets/images/mobile-membership/feature-monitoring.svg';
import FeatureReviewIcon from '@/assets/images/mobile-membership/feature-review.svg';
import FeatureShippingIcon from '@/assets/images/mobile-membership/feature-shipping.svg';

type MobileMembershipFeature = {
  iconSrc: string;
  pcSortOrder?: number;
  pcValue?: string;
  title: string;
  value?: string;
};

export const MOBILE_MEMBERSHIP_FEATURES: readonly MobileMembershipFeature[] = [
  { iconSrc: FeatureMarketIcon, title: '마켓 연동', value: '무제한' },
  { iconSrc: FeatureBellIcon, title: '데이터 수집 및 알림', value: '10분 간격' },
  {
    iconSrc: FeatureDashboardIcon,
    pcValue: '무제한',
    title: '주문·정산·배송·리뷰·문의 통합 조회',
  },
  {
    iconSrc: FeatureShippingIcon,
    pcValue: '주문확인·발송·취소 처리',
    title: '상품 발송 처리',
    value: '주문확인·발송·취소',
  },
  { iconSrc: FeatureInquiryIcon, title: '문의 답변 기능', value: 'AI 자동 생성' },
  { iconSrc: FeatureReviewIcon, title: 'AI 리뷰 답변 생성', value: '무제한' },
  { iconSrc: FeatureMonitoringIcon, pcSortOrder: 7, title: '상품 모니터링', value: '10개' },
  {
    iconSrc: FeatureAiIcon,
    pcSortOrder: 6,
    title: 'AI 상품 진단·상품명 제작',
    value: '무제한',
  },
];

export const MOBILE_MEMBERSHIP_SUPPORTS = [
  {
    title: '상품 발송 지원',
    description:
      '스마트스토어, 쿠팡, 11번가, 지마켓, 옥션, 롯데온, 톡스토어, 카페24, 샵바이, 아임웹',
  },
  {
    title: '문의 기능 지원',
    description:
      '스마트스토어, 쿠팡, 11번가, 지마켓, 옥션, 롯데온, 톡스토어, 카페24, 샵바이, 아임웹',
  },
  {
    title: '리뷰 기능 지원',
    description:
      '스마트스토어, 카페24, 아임웹, 샵바이, 에이블리, 아이디어스, 지그재그, 식스샵, 올웨이즈',
  },
  {
    title: '상품 모니터링·AI 상품 최적화 진단',
    description: '스마트스토어',
  },
] as const;

export const MOBILE_MEMBERSHIP_NOTICES = [
  '멤버십 가격은 부가세와 결제수수료가 포함되어 있습니다.',
  '등록하신 결제 수단으로 매월 정기 결제일에 멤버십 이용 금액이 자동으로 결제됩니다.',
  '멤버십은 언제든 해지할 수 있으며 해지 이후에도 결제 만료일까지 사용 가능합니다.',
  '멤버십 사용 중에는 남은 기간에 대한 금액은 별도의 환불이 진행되지 않습니다.',
  '결제 실패 시 서비스가 제한되며, 데이터는 90일동안 보관 후 삭제됩니다.',
  '얼리버드 혜택은 웹 결제 시에만 적용되며, 인앱 결제는 혜택 대상에서 제외됩니다.',
] as const;

export const PC_MEMBERSHIP_NOTICES = [
  '이벤트 할인가(첫 달 100원)는 웹 결제 시에만 적용, 앱 결제 시 정가 15,000원',
  '이벤트 종료 후 정가 15,000원 자동 전환, 전환 3일 전 사전 안내',
  '멤버십 가격은 부가세 및 결제수수료 포함',
  '매월 정기 결제일에 자동 결제',
  '언제든 해지 가능, 해지 후 만료일까지 사용 가능',
  '멤버십 사용 중 남은 기간 환불 없음',
  '결제 실패 시 서비스 제한, 데이터 90일 보관',
] as const;

export const MOBILE_PAYMENT_METHODS = [
  { value: 'CARD', label: '일반 카드' },
  { value: 'KAKAO_PAY', label: '카카오페이' },
] as const;

export const MOBILE_CARD_OWNER_TYPES = [
  { value: 'PERSONAL', label: '개인(생년월일)', placeholder: '생년월일 6자리', maxLength: 6 },
  {
    value: 'BUSINESS',
    label: '사업자(사업자 번호)',
    placeholder: '사업자번호 10자리',
    maxLength: 10,
  },
] as const;

export const MOBILE_COMPLETE_FALLBACK_FEATURES = [
  { icon: Sparkles, text: '멤버십 전체 기능 활성화' },
  { icon: Bot, text: 'AI 답변 생성 무제한 이용' },
] as const;
